var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.806 10.442l-4.667 4.375c-.416.39-1.139.117-1.139-.443v-2.5H7.222c-.369 0-.666-.278-.666-.625v-2.5c0-.345.297-.624.666-.624H11v-2.5c0-.557.72-.833 1.14-.442l4.666 4.374a.602.602 0 010 .885zm-8.472 4.244v-1.041c0-.172-.15-.313-.334-.313H5.667c-.492 0-.89-.372-.89-.833V7.5c0-.46.398-.833.89-.833H8c.184 0 .334-.14.334-.313V5.313c0-.172-.15-.312-.334-.312H5.667C4.194 5 3 6.12 3 7.5v4.998C3 13.88 4.194 15 5.667 15H8c.184 0 .334-.14.334-.313z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default ForwardRef;